import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 450,
    height: 308,
    top: '35%',
    left: '35%',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  root: { width: 382 },
  options: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  text: {
    color: '#565657',
    fontSize: '20px',
    fontWeight: 'bold',
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    jsutifyContent: 'center',
    alignItems: 'center',
    // paddingLeft: '20px',
    flexDirection: 'column',
  },
}))

export { useStyles }
